
import { defineComponent, PropType, watch } from 'vue'
import InputKin from '@/views/components/InputKin.vue'
import { TaishakuTaishoKmkType } from '@/repositories/keiei-joho/taishaku-taisho/data'
import { CorporationTypeType, corporationTypeType } from '@/views/corporation-info/types'
import { taishakuTaishoKmkTypeType as KmkType } from '@/repositories/keiei-joho/data'
import { aggregateAndSet } from '@/views/keiei-joho/taishaku-taisho/uiLogic'
import { formatNumberWithCommas } from '@/views/keiei-joho/mathUtils'

export default defineComponent({
  methods: { formatNumberWithCommas },
  components: { InputKin },
  props: {
    corporationType: {
      type: String as PropType<CorporationTypeType>
    },
    ryudoFusaiItems: {
      type: Array as PropType<TaishakuTaishoKmkType[]>,
      required: true
    },
    koteiFusaiItems: {
      type: Array as PropType<TaishakuTaishoKmkType[]>,
      required: true
    },
    fusaiGokei: {
      type: Object as PropType<TaishakuTaishoKmkType>,
      required: true
    },
    isDisabledByCorporationType: {
      type: Function as PropType<(item: TaishakuTaishoKmkType) => boolean>,
      required: true
    }
  },
  emits: {
    updateFusaiGokei: (val: number) => true
  },
  setup (props, { emit }) {
    // 法人タイプ１以外の場合の自動計算
    watch(
      [
        () => props.ryudoFusaiItems.filter(v => !v.isAggregate),
        () => props.koteiFusaiItems.filter(v => !v.isAggregate)
      ],
      () => {
        if (props.corporationType === corporationTypeType.Type1) return

        const ryudo = aggregateAndSet(props.ryudoFusaiItems, KmkType.RyudoFusai)
        const kotei = aggregateAndSet(props.koteiFusaiItems, KmkType.KoteiFusai)
        if (props.fusaiGokei) {
          emit('updateFusaiGokei', ryudo + kotei)
        }
      },
      {
        deep: true
      }
    )

    // 法人タイプ１の場合の自動計算
    watch(
      [
        () => props.ryudoFusaiItems.find(v => v.kmkType === KmkType.RyudoFusai)?.kin ?? 0,
        () => props.koteiFusaiItems.find(v => v.kmkType === KmkType.KoteiFusai)?.kin ?? 0
      ],
      ([ryudo, kotei]) => {
        if (props.corporationType !== corporationTypeType.Type1) return

        if (props.fusaiGokei) {
          emit('updateFusaiGokei', ryudo + kotei)
        }
      }
    )
  }
})
